// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--KEDIr"};